import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { LineModalTemplateComponent } from './components/line-modal-template/line-modal-template.component';
import { ModalService } from './modal.service';

@NgModule({
    declarations: [ModalContainerComponent, LineModalTemplateComponent],
    imports: [
        CommonModule
    ],
    providers: [ModalService]
})
export class ModalModule { }
